<template>
    <project-template>

        <project-video
        size="100"
        videoID="348096883" />

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>The Backstory</h1>
          <p>Bigelow, one of the leading tea producers in the United States, needed a series of videos to illustrate the care that goes into making a cup of their tea. They wanted to emphasize that they only use the finest ethically-sourced ingredients. I created a uniform look and feel for the series and animated 10 videos, each one focused on a specific tea or ingredient.</p>
        </project-text>

        <project-video
        size="75"
        videoID="348096904" />

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Settling is not an Option</h1>
          <p>Planning is at the core of these videos. Before animating each ingredient video, I created storyboards to send off to Bigelow for approval. With this necessary first step, I was able to ensure that the finished product would tell the story just how they envisioned it.</p>
        </project-text>

        <project-carousel
        size="50"
        :color="$store.state.activeProject.color"
        :autoplay="true">
          <slide><img v-lazy="'/img/p/bigelow/mint-medley.jpg'" alt="Mint Medley Storyboard"></slide>
          <slide><img v-lazy="'/img/p/bigelow/green-tea.jpg'" alt="Green Tea Storyboard"></slide>
          <slide><img v-lazy="'/img/p/bigelow/green-tea-lemon.jpg'" alt="Green Tea with Lemon Storyboard"></slide>
        </project-carousel>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>The Results</h1>
          <p>Bigelow posted these videos on their social media channels and ran a paid social advertising campaign. With over 200,000 views across the set of videos, Bigelow was able to show tea lovers across the country that when it comes to their tea, the difference is in the details.</p>
        </project-text>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'
import ProjectCarousel from '../../components/project/ProjectCarousel.vue'
import { Slide } from 'vue-carousel'

export default {
  components: { ProjectTemplate, ProjectText, ProjectVideo, ProjectCarousel, Slide }
}
</script>

<style lang="scss" scoped>

</style>
